import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, OnInit, Output, Renderer2, ViewChild, ViewContainerRef } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';


import { columnsDef } from 'src/app/interfaces/columnsDef';
import { MaskEditField } from 'src/app/interfaces/user-authentication';
import { DynamicFormsService } from 'src/app/services/dynamic-forms.service';

@Component({
    selector: 'app-form-view-action',
    templateUrl: './form-view-action.component.html',
    styleUrls: ['./form-view-action.component.css'],
    standalone: false
})
export class FormViewActionComponent implements OnInit,AfterViewInit {

  config:columnsDef;
  group: UntypedFormGroup;
  row: Object;
  componentHidden:Boolean = false;
  maskEditField:MaskEditField;
  entityName:string;
  tabindex:string;  
  action_icon:string;
  disableAction:boolean = false;
  component:any;
  toolTip:string;
  validation:string;
  widthPopUp:number;
  canConfig:boolean = false;
  toolTipText = null;
  @Output() editEvent:EventEmitter<boolean> = new EventEmitter();
  
  constructor(public dynaServices:DynamicFormsService,private cd:ChangeDetectorRef) { 
      
  }
  
  @Output() blurEvent:EventEmitter<boolean> = new EventEmitter();
  
  bluring(event){
      this.blurEvent.next(event)
  }

  ngAfterViewInit(){
    if ( this.maskEditField != null){
      if ( this.maskEditField.padding !=null){
        let value = this.group.get(this.config.COLUMNNAME).value;
        if ( value != null ){
          let m = this.maskEditField.mask;
          m = m.replace(/\./g,'');
          let k = value.toString().padStart(m.length,'0');
          this.group.get(this.config.COLUMNNAME).patchValue(k);
          this.cd.detectChanges();
        }
        
      }
    }    
  }

  ngOnInit() {

    
  }

  format(evento,value){
      
     if ( this.maskEditField.mask.indexOf("separator")>-1){
      let decimal =  this.maskEditField.mask.split(/\./g)[1];
      //value =  this.realValue.toString().split(/\./g)[0] + ", "+this.realValue.toString().split(/\./g)[1].padEnd(decimal,0);
     }
  }

  editing(){
    this.editEvent.next(true);
  }

  actionClick(evento){
    this.group.get(this.config.COLUMNNAME).setValue(null);
  }

  formSubmitted(evento){
    this.group.get(this.config.COLUMNNAME).setValue(evento);
    this.editEvent.next(true);
  }

  canceling(evento){
    this.editEvent.next(true);
  }

}
